import { render, staticRenderFns } from "./dangerRegularCheckEtc.vue?vue&type=template&id=8b2b3fb8"
import script from "./dangerRegularCheckEtc.vue?vue&type=script&lang=js"
export * from "./dangerRegularCheckEtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b2b3fb8')) {
      api.createRecord('8b2b3fb8', component.options)
    } else {
      api.reload('8b2b3fb8', component.options)
    }
    module.hot.accept("./dangerRegularCheckEtc.vue?vue&type=template&id=8b2b3fb8", function () {
      api.rerender('8b2b3fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerRegularCheckEtc.vue"
export default component.exports